// extracted by mini-css-extract-plugin
export var section = "installment-module--section--Vf1E6";
export var container = "installment-module--container--cuL-r";
export var wrap = "installment-module--wrap--nP4Sm";
export var title = "installment-module--title--kc5U2";
export var text = "installment-module--text--hR2IN";
export var list = "installment-module--list--e0ONP";
export var subTitle = "installment-module--subTitle--KC0ji";
export var description = "installment-module--description--n8dwv";
export var bottomText = "installment-module--bottomText--nAUpJ";